import React from 'react';
//import { validate } from 'jsonschema';
import ObjectField from 'react-jsonschema-form/lib/components/fields/ObjectField';
import { orderProperties, retrieveSchema, getDefaultRegistry } from 'react-jsonschema-form/lib/utils';

class BaseObjectField extends ObjectField {
  onPropertyChange = (name, validatorKey) => {
    return (value, options) => {
      const { formContext: { onFormControlChange } } = this.props;
      onFormControlChange(validatorKey);

      const newFormData = { ...this.props.formData, [name]: value };
      this.props.onChange(newFormData, options, validatorKey);
    };
  };
  /*
  onPropertyFocus = (name, id, validatorKey) => {
    return () => {
      const { formContext : { onFormControlFocus } } = this.props;
      onFormControlFocus(validatorKey);

      this.props.onFocus && this.props.onFocus(arguments);
    };
  };

  onPropertyBlur = (name, id, validatorKey) => {
    return () => {
      const { formContext : { onFormControlBlur } } = this.props;
      onFormControlBlur(validatorKey);

      this.props.onBlur && this.props.onBlur(arguments);
    };
  };
*/
  render() {
    const {
      uiSchema,
      formData,
      errorSchema,
      idSchema,
      name,
      //required,
      disabled,
      readonly,
      onBlur,
      onFocus,
      registry = getDefaultRegistry(),
      RootComponent,
    } = this.props;

    const { definitions, fields /*, formContext*/ } = registry;
    const { SchemaField /*, TitleField, DescriptionField*/ } = fields;
    const schema = retrieveSchema(this.props.schema, definitions);
    //const title = schema.title === undefined ? name : schema.title;
    const errorStyle = { color: 'red' };
    let orderedProperties;
    try {
      const properties = Object.keys(schema.properties);
      orderedProperties = orderProperties(properties, uiSchema['ui:order']);
    } catch (err) {
      return (
        <div>
          <p className="config-error" style={errorStyle}>
            Invalid {name || 'root'} object field configuration:
            <em>{err.message}</em>.
          </p>
          <pre>{JSON.stringify(schema)}</pre>
        </div>
      );
    }

    const renderProps = orderedProperties.map((name, index) => {
      //const id = idSchema[name]['$id'];
      const validatorKey = uiSchema[name]['ui:options'].validatorKey;
      // if(errorSchema[name]) console.log(errorSchema[name]);
      return (
        <SchemaField
          key={index}
          name={name}
          required={this.isRequired(name)}
          schema={schema.properties[name]}
          uiSchema={uiSchema[name]}
          errorSchema={errorSchema[name]}
          idSchema={idSchema[name]}
          formData={formData[name]}
          onChange={this.onPropertyChange(name, validatorKey)}
          onBlur={onBlur}
          onFocus={onFocus}
          registry={registry}
          disabled={disabled}
          readonly={readonly}
        />
      );
    });

    return RootComponent ? (
      <RootComponent {...this.props} orderedProperties={orderedProperties}>
        {renderProps}
      </RootComponent>
    ) : (
      <div>{renderProps}</div>
    );
  }
}

export default BaseObjectField;



// WEBPACK FOOTER //
// ./src/modules/common/components/form/fields/BaseObjectField.js